import KendoValidator from './KendoValidator'
import KendoValidatorInstaller from './kendo-validator-installer'

export { KendoValidator, KendoValidator as Validator, KendoValidatorInstaller, KendoValidatorInstaller as ValidatorInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-validator-vue-wrapper/src/index.js